/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Add_User_To_Group_FailedInputs */



/**
* | output |
* | --- |
* | "Error adding user to group. {error}" |
*
* @param {Team_Manager_Add_User_To_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_user_to_group_failed = /** @type {((inputs: Team_Manager_Add_User_To_Group_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_User_To_Group_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de l’ajout de l’utilisateur au groupe. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Hinzufügen des Benutzers zur Gruppe. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'aggiunta dell'utente al gruppo. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при добавлении пользователя в группу. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al agregar usuario al grupo. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`将用户添加到组时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ユーザーをグループに追加中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`समूह में उपयोगकर्ता जोड़ने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao adicionar usuário ao grupo. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error adding user to group. ${i?.error}`)
});